import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAmJDZ89X_xNTEA2W4ASUE8CFQxypk0S08",
  authDomain: "kgfkhana-cb2fc.firebaseapp.com",
  projectId: "kgfkhana-cb2fc",
  storageBucket: "kgfkhana-cb2fc.firebasestorage.app",
  messagingSenderId: "1061196851384",
  appId: "1:1061196851384:web:e547a4a217a99c9fa1ec4d",
  measurementId: "G-TV5V520XP5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

export default app;
